import React from 'react';

export default function HomeFooter() {
  return (
    <footer className="border-t border-white/[0.06]" style={{ background: 'rgba(9,9,11,0.98)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          <div className="flex flex-col gap-4 max-w-xs">
            <div className="flex items-center gap-2.5">
              <img src="/logo.png" alt="STUDO.ID" className="h-8 w-8 object-contain" />
              <span className="text-white font-bold text-lg tracking-tight">
                STUDO<span style={{ color: '#8cc63f' }}>.ID</span>
              </span>
            </div>
            <p className="text-zinc-400 text-[13px] leading-relaxed">
              Kreatif Studio — komunitas para creator digital yang berfokus pada AI dan Automation. Kami menciptakan solusi digital inovatif — dari creative HUB, website development, chatbot cerdas, hingga sistem otomasi digital.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-10 sm:gap-16">
            <div className="flex flex-col gap-4">
              <span className="text-[11px] font-semibold tracking-[0.15em] uppercase text-white/40">Navigasi</span>
              <div className="flex flex-col gap-3">
                {['Beranda', 'Layanan', 'Keunggulan', 'Kontak'].map(item => (
                  <a key={item} href={`#${item.toLowerCase()}`} className="text-[14px] font-medium text-zinc-400 hover:text-white transition-colors">
                    {item}
                  </a>
                ))}
              </div>
            </div>
            <div className="flex flex-col gap-4">
              <span className="text-[11px] font-semibold tracking-[0.15em] uppercase text-white/40">Layanan</span>
              <div className="flex flex-col gap-3">
                {['AgencyHUB', 'AI Integration', 'Automation', 'Konsultasi'].map(item => (
                  <a key={item} href="#layanan" className="text-[14px] font-medium text-zinc-400 hover:text-white transition-colors">
                    {item}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[13px] text-white/30">
            © {new Date().getFullYear()} STUDO.ID — kreatif.studo.id. Semua hak dilindungi.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-[13px] font-medium text-white/40 hover:text-white transition-colors">Kebijakan Privasi</a>
            <a href="#" className="text-[13px] font-medium text-white/40 hover:text-white transition-colors">Syarat & Ketentuan</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
